import React from "react";

export interface TableColumn {
  label: string;
  className?: string;
}

interface CustomTableProps {
  columns: TableColumn[];
  children: React.ReactNode;
  className?: string;
}

const CustomTable: React.FC<CustomTableProps> = ({ columns, children, className }) => (
  <div className={`w-full max-w-full overflow-x-auto overscroll-x-contain ${className || ""}`}>
    <table className="w-full min-w-[720px] border-separate border-spacing-y-2">
      <thead>
        <tr className="bg-purple-800 text-white">
          {columns.map((col, idx) => (
            <th key={idx} className={col.className || "px-6 py-4 text-left text-sm font-medium"}>
              {col.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {children}
      </tbody>
    </table>
  </div>
);

export default CustomTable;
